import { Sparkles } from "lucide-react";

// Universal Version 2 preview curtain. Renders a warm amber banner at the top
// (VERSION 2 PREVIEW + description + V2 pill), then shows a glimpse of the
// wrapped content in a `max-h-[520px]` frame, fades the bottom, and stamps a
// floating "Full experience arrives in Version 2" pill on top. Used any time
// a module was explicitly deferred to Version 2 per user directive.
//
// Props:
//   label:       Short module name shown in the data-testid.
//   description: One-liner describing what V2 will add.
//   maxHeight:   Optional. Height of the glimpse frame in px, defaults to 520.
//   children:    The real module content, rendered but non-interactive.
export function V2Preview({ label, description, maxHeight = 520, children }) {
  return (
    <div className="relative" data-testid={`v2-preview-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="mb-3 flex items-center justify-between rounded-2xl border border-[#FFCC80] bg-[#FFF3E0] px-4 py-3">
        <div>
          <div className="flex items-center gap-2 text-[#8D5A00]">
            <Sparkles size={14} />
            <span className="text-xs font-bold uppercase tracking-wider">Version 2 preview</span>
          </div>
          <div className="mt-1 text-xs text-[#6D4C41]">{description}</div>
        </div>
        <span className="rounded-full bg-[#FFB300] px-2.5 py-1 text-[10px] font-bold text-[#3E2723]">V2</span>
      </div>
      <div className="relative overflow-hidden rounded-2xl">
        <div className="pointer-events-none overflow-hidden" style={{ maxHeight }}>{children}</div>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-56 bg-gradient-to-t from-[#FDFCF8] via-[#FDFCF8]/85 to-transparent" />
        <div className="absolute inset-x-0 bottom-4 flex justify-center">
          <div className="rounded-full bg-white px-4 py-2 text-xs font-bold text-[#4E342E] shadow-[0_10px_28px_-8px_rgba(62,39,35,0.35)]">
            Full experience arrives in Version 2
          </div>
        </div>
      </div>
    </div>
  );
}

export default V2Preview;
